import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { first } from 'rxjs';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { FarmersDetailsService } from 'src/app/services/farmers-details.service';
import { IpAddressService } from 'src/app/services/ip-address.service';
import { VendorDashboardService } from 'src/app/services/vendor-dashboard.service';

@Component({
  selector: 'app-change-vendor',
  templateUrl: './change-vendor.component.html',
  styleUrls: ['./change-vendor.component.scss'],
})
export class ChangeVendorComponent implements OnInit {
  public applicationForm: FormGroup;
  public isSubmitted: boolean = false;
  public statusMessage: any;
  public pogramNameList: any;
  public isAppEditable: boolean = false;
  public showStatusArea: boolean = false;
  public actionType: any;
  public actionMasterList: any;
  public hideAppDetailsArea: boolean = false;
  public userID: any;
  public ipAddress: any = '000.000.000';
  public updatedProgramId: any;
  public updatedVendorId: any;
  public vendorNameList: any;
  public filteredVendorList: any;
  public selectedProgram: any;
  public selectedProgramList: any;

  public supportingDocPath: any;
  public farmerAppDetails: any;
  public farmerId: any;

  constructor(
    private fb: FormBuilder,
    private loader: AppLoaderService,
    private vendorDashboardService: VendorDashboardService,
    private deptDashBoardService: DepartmentDashboardService,
    private messageService: MessageService,
    private ipService: IpAddressService,
    private uploadDocService: FarmersDetailsService,
    private cryptoJsService: CryptoJsService,
    private dashboard: DashboardService
  ) { }

  ngOnInit(): void {
    // let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    // let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    // this.userID = JSON.parse(payload)?.sub;

    const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    const farmerConfData = new Map(encData);
    let farmerData = farmerConfData.get('farmerDetails');

    this.farmerId = farmerConfData.get('Farmer_Id_');


    this.applicationForm = this.fb.group({
      applicationNo: ['', Validators.required],
      programId: [''],
    });

    this.getFarmerQueriesActionMaster();
    this.getIP();
    this.getApplicationIds();
  }

  get f() {
    return this.applicationForm.controls;
  }

  getApplicationIds() {
    const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    const farmerConfData = new Map(encData);
    let farmerId = farmerConfData.get('Farmer_Id_');

    this.loader.start();
    this.dashboard.getApplicationByFarmerId(farmerId)
      .pipe(first())
      .subscribe({
        next: (resData) => {
          // let res = JSON.parse(this.cryptoJsService.DecryptToken(resData.data));

            this.farmerAppDetails = resData.filter(
            (value, index, self) =>
              index === self.findIndex((t) => t.appID === value.appID)
            );
          this.loader.close();
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  hideEditableArea() {
    this.isAppEditable = false;
    this.showStatusArea = false;
    this.actionType = null;
  }

  submitApplication() {
    this.hideEditableArea();
    this.isSubmitted = true;

    if (this.applicationForm.valid) {
      // console.log(this.applicationForm.value);
      this.getSelectedProgram(this.applicationForm.value['applicationNo'])
    }
  }

  checkAppStatus(reqBody) {
    let reqBodyAfterEncypt = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
    }

    this.loader.start();
    this.deptDashBoardService
      .getAppLastStatus(reqBodyAfterEncypt)
      .pipe(first())
      .subscribe({
        next: (resp) => {
          this.loader.close();
          if (resp.length > 0) {
            let respVal = resp[0];
            this.showStatusArea = true;

            this.statusMessage = respVal?.Status;

            if (respVal?.IsEditable == 1) {
              this.isAppEditable = true;
              this.hideAppDetailsArea = true;
            } else {
              this.isAppEditable = false;
            }
            // console.log(this.isAppEditable)
          }
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  getFarmerQueriesActionMaster() {
    this.loader.start();
    this.deptDashBoardService
      .getFarmerQueriesActionMaster()
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          data = data.filter(item => item.Action_ID !== 1);
          this.actionMasterList = data;
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  clearAppNo() {
    this.f.applicationNo.setValue(null);
    this.showStatusArea = false;
    this.statusMessage = null;
    this.selectedProgramList = null;

    this.cancelChangeRequest();
  }

  getChangeProgram(event) { }


  getAllMIVendors(programId) {
    this.loader.start();
    this.vendorDashboardService
      .getAllMIVendors(programId)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.vendorNameList = res;
          this.loader.close();
        },
        error: () => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data error! Category not loaded.',
          });
        },
      });
  }

  getSelectedProgram(appId) {
    let reqBody = {
      appId: appId
    }

    let reqBodyAfterEncypt = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
    }
    this.loader.start();
    this.deptDashBoardService
      .getSelectedProgram(reqBodyAfterEncypt)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          this.selectedProgramList = data;
          if (data.length > 0) {
            this.selectedProgram = data[0];
            this.f.programId.setValue(this.selectedProgram?.Program_Id);
            let reqBoady = {
              appId: this.applicationForm.value['applicationNo'],
              progId: this.selectedProgram?.Program_Id,
            };
            this.checkAppStatus(reqBoady);
          } else {
            this.messageService.add({
              severity: 'error',
              summary: 'Error Message',
              detail: 'Programme name not found',
            });
          }
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  getProgramToBeChanged(appId) {
    this.loader.start();
    this.deptDashBoardService
      .getProgramToBeChanged(appId)
      .pipe(first())
      .subscribe({
        next: (files) => {
          this.loader.close();
          this.pogramNameList = files;
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  submitChangeRequest() {
    if (this.actionType == null || this.actionType == undefined) {
      this.messageService.add({
        severity: 'info',
        summary: 'Info Message',
        detail: 'Select the Action Type',
      });
      return;
    }

    if (this.actionType == 3 && (this.updatedProgramId == null || this.updatedProgramId == undefined)) {
      this.messageService.add({
        severity: 'info',
        summary: 'Info Message',
        detail: 'Select Programme Name',
      });
      return;
    } else if (this.actionType == 2 && (this.updatedVendorId == null || this.updatedVendorId == undefined)) {
      this.messageService.add({
        severity: 'info',
        summary: 'Info Message',
        detail: 'Select Vendor Name',
      });
      return;
    }

    if (!this.applicationForm.valid) {
      this.messageService.add({
        severity: 'info',
        summary: 'Info Message',
        detail: 'Select required field properly',
      });
      return;
    }

    if (this.supportingDocPath == null || this.supportingDocPath == undefined) {
      this.messageService.add({
        severity: 'info',
        summary: 'Info Message',
        detail: 'Upload Supporting Document',
      });
      return;
    }

    const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    const farmerconfData = new Map(encData);
    let farmerMobileNo = farmerconfData.get('farmerPh') ? farmerconfData.get('farmerPh') : '';

    let reqBody = {
      MobileNo: farmerMobileNo,
      appId: this.applicationForm.value['applicationNo'],
      docPath: this.supportingDocPath,
      // existingProgId: this.applicationForm.value['programId'],
      existingProgId: this.selectedProgram?.Program_Id,
      updatedProgId: this.actionType == 2 ? 0 : this.updatedProgramId,
      actionId: this.actionType,
      vendorId: this.actionType == 2 ? JSON.stringify(this.updatedVendorId?.Vendor_Code) : JSON.stringify(0),
      userId: this.farmerId,
      netWork_Id: this.ipAddress,
      terminal_Id: this.ipAddress,
    }
    this.submitFarmerChangeQueries(reqBody);

  }

  submitFarmerChangeQueries(reqBoady) {
    let reqBodyAfterEncypt = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBoady))
    }

    this.loader.start();
    this.deptDashBoardService
      .addFarmerQueries(reqBodyAfterEncypt)
      .pipe(first())
      .subscribe({
        next: (resp) => {
          this.loader.close();
          if (resp == 'Success') {
            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: resp,
            });
            this.cancelChangeRequest();
          } else {
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: resp,
            });
          }
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  cancelChangeRequest() {
    this.hideAppDetailsArea = false;
    this.actionType = null;
    this.showStatusArea = false;
    this.supportingDocPath = null;
  }

  getIP() {
    const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    const farmerConfData = new Map(encData);
    let ipAddress = farmerConfData.get('ipAddress');

    if (ipAddress) {
      this.ipAddress = ipAddress;
    } else {
      this.ipService.getIPAddress().subscribe((res: any) => {
        this.ipAddress = res.ip;

        farmerConfData.set('ipAddress', this.ipAddress)

        const dataF = JSON.stringify(Array.from(farmerConfData.entries()));
        sessionStorage.setItem('dataF', this.cryptoJsService.EncryptSession(dataF));  
      });
    }
  }

  onChangeActionType(event) {
    // console.log(event.value)
    this.vendorNameList = null;
    this.updatedVendorId = null;
    if (event.value == 2) {
      this.updatedProgramId = null;
      // this.getAllMIVendors(this.applicationForm.value['programId']);
      this.getAllMIVendors(this.selectedProgram?.Program_Id);
    } else if (event.value == 3) {
      this.updatedVendorId = null;
      this.getProgramToBeChanged(this.applicationForm.value['applicationNo']);
    } else {
      this.updatedProgramId = null;
      this.updatedVendorId = null;
    }
  }

  onVendorSelect(event) { }

  filterMIVendor(event: any) {
    const filtered: any[] = [];
    const query = event.query;
    for (let i = 0; i < this.vendorNameList.length; i++) {
      const vendor = this.vendorNameList[i];
      if (vendor.Name.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(vendor);
      }
    }
    this.filteredVendorList = filtered;
  }

  onUpload(event, formcontrol, uploadElement) {
    const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    const farmerconfData = new Map(encData);
    let farmerMobileNo = farmerconfData.get('farmerPh') ? farmerconfData.get('farmerPh') : '';

    let file = event.files[0];
    let data = new FormData();
    data.append('file', file);

    this.loader.start();
    this.uploadDocService.uploadFile(data,  `${farmerMobileNo}-farmer_query`, formcontrol)
      .subscribe(
        (resp: any) => {
          this.loader.close();
          if (resp.statusCode == 200) {
            this.supportingDocPath = resp.data;
          } else {
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'resp',
            });
          }
        },
        (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        }
      );
    uploadElement.clear();
  }
}
